// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__26d9M","link":"Navbar_link__1hqGc","active":"Navbar_active__21R_N","icon":"Navbar_icon__dXO0O"};